
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/living/register-interest",
      function () {
        return require("private-next-pages/living/register-interest.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/living/register-interest"])
      });
    }
  